import {Navigate} from "react-router-dom";

import {useStoredMe} from "@/src/modules/core/store/me";

import {vehicleChecksService} from "../services";

export default function VehicleChecksSectionGuard({children}: {children: React.ReactNode}) {
  const me = useStoredMe();

  if (!vehicleChecksService.getCanAccessVehicleChecksHistory(me)) {
    return <Navigate to={me?.isAdmin ? "/dashboard" : "/dars"} replace />;
  }

  return <>{children}</>;
}
